import restClient from "../restClient";

const endpoint = "/communications-templates";

export const getCommunicationsTemplates = async (params) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params
    };
    const response = await restClient.get(endpoint, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createCommunicationsTemplate = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(endpoint, { data }, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getCommunicationsTemplate = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateCommunicationsTemplate = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`${endpoint}/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteCommunicationsTemplate = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};
